import { render, staticRenderFns } from "./incidentReportBackToWork.vue?vue&type=template&id=55ee8d0c"
import script from "./incidentReportBackToWork.vue?vue&type=script&lang=js"
export * from "./incidentReportBackToWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports